module.exports = __webpack_public_path__ + "static/media/ic-f-a-b-add.5a57d8ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ic-f-a-b-add.svg
// module id = 777
// module chunks = 0